// extracted by mini-css-extract-plugin
export default {"page":"mr-z","landingBackground":"nr-z","nonLandingBackground":"or-z"};